import axios from "axios";

export const backendURL =
    process.env.NODE_ENV !== "production"
        ? "http://localhost:8000"
        : "";

export const baseURL =
    process.env.NODE_ENV !== "production"
        ? "http://localhost:8000/api/"
        : "/api/";

    // process.env.NODE_ENV !== "production"
    //     ? "https://71b5-202-8-114-116.ngrok.io/api/"
    //     : "/api/";

const mainService = axios.create({
    baseURL: baseURL,
    // withCredentials: true,
    headers: {
        Authorization: "Bearer " + localStorage.getItem("auth_token"),
        "Content-Type": "mainServicelication/json",
        Accept: "mainServicelication/json"
    }
});

export default mainService;



// WEBPACK FOOTER //
// ./src/services/mainService.jsx